import React, { useEffect, useState } from "react";
import API from "../services/api";
import { updateStoredUser } from "../utils/sessionUser";
import "./GovernmentPortal.css";

const emptyProfile = {
  fullName: "",
  mobile: "",
  email: "",
  officerCode: "",
  area: "",
  designation: "",
  officeName: "",
  district: "",
};

const GovernmentProfile = () => {
  const [form, setForm] = useState(emptyProfile);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    API.get("/government/profile")
      .then(({ data }) => {
        if (!active) return;
        setForm({
          fullName: data.fullName || "",
          mobile: data.mobile || "",
          email: data.email || "",
          officerCode: data.governmentProfile?.officerCode || "",
          area: data.governmentProfile?.area || "",
          designation: data.governmentProfile?.designation || "",
          officeName: data.governmentProfile?.officeName || "",
          district: data.governmentProfile?.district || "",
        });
      })
      .catch((err) => active && setError(err?.response?.data?.message || "Profile load nahi ho saka."))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");
    setError("");
    try {
      const { data } = await API.put("/government/profile", form);
      updateStoredUser(data.user);
      setMessage(data.message || "Profile update ho gaya.");
    } catch (err) {
      setError(err?.response?.data?.message || "Profile update nahi ho saka.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="gov-page"><div className="gov-card">Profile load ho raha hai...</div></div>;

  return (
    <div className="gov-page gov-profile-page">
      <div className="gov-hero">
        <div>
          <p className="gov-kicker">Government account</p>
          <h1>My Profile</h1>
          <p>Apni officer aur office details dekhein aur update karein.</p>
        </div>
        <span className="material-symbols-outlined gov-profile-icon">badge</span>
      </div>

      <form className="gov-card gov-profile-form" onSubmit={save}>
        {message && <div className="gov-profile-message success">{message}</div>}
        {error && <div className="gov-profile-message error">{error}</div>}
        <div className="gov-profile-grid">
          <label>Full name<input value={form.fullName} onChange={(e) => update("fullName", e.target.value)} required /></label>
          <label>Mobile number<input inputMode="numeric" value={form.mobile} onChange={(e) => update("mobile", e.target.value)} required /></label>
          <label>Email<input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} /></label>
          <label>Officer code<input value={form.officerCode} onChange={(e) => update("officerCode", e.target.value)} /></label>
          <label>Designation<input value={form.designation} onChange={(e) => update("designation", e.target.value)} /></label>
          <label>Area / Mandi<input value={form.area} onChange={(e) => update("area", e.target.value)} /></label>
          <label>Office name<input value={form.officeName} onChange={(e) => update("officeName", e.target.value)} /></label>
          <label>District<input value={form.district} onChange={(e) => update("district", e.target.value)} /></label>
        </div>
        <button className="gov-primary" type="submit" disabled={saving}>{saving ? "Saving..." : "Save profile"}</button>
      </form>
    </div>
  );
};

export default GovernmentProfile;
